
  import missions from '~/mixins/pages/mission-control/missions'
  export default {
    name: 'Theme2MissionRoadmapLayoutsTypeTwo',
    mixins: [missions],
    props: {
      eventType: {
        type: String,
        default: 'weekly'
      },
      missionActivities: {
        type: Array,
        default: () => []
      },
      missionId: {
        type: String,
        default: ''
      },
      extraCoin: {
        type: Number,
        default: 0
      },
      isAllClaimed: {
        type: Boolean,
        default: false
      },
      extraCoinStatus: {
        type: Number,
        default: 0
      },
      missionActivitiesLoading: {
        type: Boolean,
        default: false
      } // This mission loading will be true only when the query string is changed
    },
    data() {
      return {
        displayActivityDetailDialog: false,
        displaySuccessClaimDialog: false,
        selectedDate: '',
        selectedItemDetail: {},
        claimLoading: {},
        claimedAmount: 0,
        claimExtraCoinLoading: false,
        missionQueryStringHasChanged: null
      }
    },
    computed: {
      getActivitiesByDate() {
        if (!this.selectedDate) return []
        const findActivities = this.missionActivities.find(el => el.date === this.selectedDate)
        if (!findActivities) return []
        return findActivities.activities
      }
    },
    watch: {
      missionActivities(value, oldValue) {
        if ((value && !oldValue?.length) || this.missionQueryStringHasChanged) {
          const findMatchDate = value.find(
            el => el.date === this.$dayjs(new Date()).format('YYYY-MM-DD')
          )
          this.selectedDate = findMatchDate ? findMatchDate?.date : value[0]?.date
          this.setDefaultSelectedDate()
          this.missionQueryStringHasChanged = false
        } else {
          const findMatchDate = value.find(
            el => el.date === this.$dayjs(new Date()).format('YYYY-MM-DD')
          )
          this.selectedDate = findMatchDate ? findMatchDate?.date : value[0]?.date
          this.setDefaultSelectedDate()
        }
      },
      '$route.query.mission_id'(value) {
        this.missionQueryStringHasChanged = true
      }
    },
    mounted() {
      if (this.missionActivities.length) {
        // this.selectedDate = this.missionActivities[0].date
        const findMatchDate = this.missionActivities.find(
          el => el.date === this.$dayjs(new Date()).format('YYYY-MM-DD')
        )
        this.selectedDate = findMatchDate ? findMatchDate?.date : this.missionActivities[0]?.date
      }
      this.setDefaultSelectedDate()
    },
    methods: {
      onDisplayActivityDetailDialog(item) {
        if (this.claimLoading[item.activity_id]) return
        this.selectedItemDetail = item
        this.selectedItemDetail.img = item.is_extra_coin
          ? `${this.$config.BUCKET_ROOT}/assets/mission_control/basic_settings/${this.missionsSettings.file}`
          : `${this.$config.BUCKET_ROOT}/assets/mission_control/missions/${this.missionId}/activities/${item.file}`
        this.displayActivityDetailDialog = true
      },
      async onClaimActivity(item) {
        if (item.status === 1 || item.status === 3) return
        let claimParams = {
          activity_id: item.activity_id,
          mission_id: this.missionId
        }
        let claimPath = 'activities/mission-reward/claimActivity'
        if (item.is_extra_coin) {
          this.claimExtraCoinLoading = true
          claimParams = this.missionId
          claimPath = 'activities/mission-reward/onClaimExtraCoin'
        }
        this.claimLoading = {
          ...this.claimLoading,
          [item.activity_id]: true
        }
        this.claimedAmount = item.reward_amount
        const response = await this.$store.dispatch(claimPath, claimParams)
        if (response) {
          // To get notifications
          this.$store.dispatch('activities/notification/getNotifications')
          // To get player coin balance
          this.$store.dispatch('player/totalBalance')
          await this.fetchMissionDetail()
          // Display success dialog, and hide it after 1.5 seconds
          this.displaySuccessClaimDialog = true
          setTimeout(() => {
            this.displaySuccessClaimDialog = false
          }, 1500)
        }
        // this.displaySuccessClaimDialog = true
        this.claimLoading[item.activity_id] = false
        this.claimExtraCoinLoading = false
      },
      async fetchMissionDetail() {
        await this.$store.dispatch(
          'activities/mission-reward/getMissionById',
          this.$route.query.mission_id
        )
      },
      async setDefaultSelectedDate() {
        await new Promise(resolve => {
          setTimeout(() => {
            resolve()
          }, 300)
        })
        const activityId = this.$route.query.activity_id
        // find the selected date by activity id

        // Set the selected date to today if it exists in missionActivities
        const currentDate = this.$dayjs(new Date()).format('YYYY-MM-DD')
        let selectedDate = this.missionActivities.find(el => el.date === currentDate)
        if (activityId) {
          selectedDate = this.missionActivities.find(el => {
            if (el.activities.some(ac => ac.activity_id === activityId)) {
              return true
            }
            return false
          })
        }
        if (selectedDate) {
          this.selectedDate = selectedDate.date
          // Auto scrolling
          setTimeout(() => {
            const target = document.getElementById('target-date')

            // Auto Scroll to the selected activity date
            if (target) {
              target.scrollIntoView({
                behavior: 'smooth',
                inline: 'nearest'
              })
            }
          }, 300)
        }
      }
    }
  }
